import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { disableHome, disableHotelDetail, disableHotelList, redirectURIV2 } from "environments/properties";
import { Observable } from "rxjs";
import { AuthenticationService } from "../authentication/authentication.service";

@Injectable()
export class PageGuard implements CanActivate {

  constructor(private authService: AuthenticationService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const path = state.url.split('?')[0];
    switch (path) {
      case '/':
        if (disableHome) {
          window.location.href = `${redirectURIV2}${state.url}`;
          return false;
        }
        break;
      case '/hotel/searchdestination':
        if (disableHotelList) {
          window.location.href = `${redirectURIV2}${state.url}`;
          return false;
        }
        break;
    }
    if (path.includes('/hotel/detail')) {
      if (disableHotelDetail || this.authService.isB2CClient()) {
        const newPath = state.url.replace('/hotel/detail', '/hotel');
        window.location.href = `${redirectURIV2}${newPath}`;
        return false;
      }
    }
    if (path.includes('/pre-approval')) {
      window.location.href = `${redirectURIV2}${state.url}`;
      return false;
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/guard/page.guard.ts